<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :md="8" :sm="12">
              <a-form-item label="更新时间">
                <a-range-picker
                  v-model="queryParam.timeRange"
                  format="YYYY-MM-DD"
                  style="width: 100%"/>
              </a-form-item>
          </a-col> -->

          <a-col :md="6" :sm="8">
            <a-form-item label="交易编号">
              <a-input
                placeholder="请输入交易编号"
                v-model="queryParam.payinId"/>
            </a-form-item>
          </a-col>
          
          <a-col :md="6" :sm="8">
            <a-form-item label="订单编号">
              <a-input
                placeholder="请输入订单编号"
                v-model="queryParam.orderNo"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="手机号码">
              <a-input
                placeholder="请输入手机号码"
                v-model="queryParam.mobileNo"/>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item label="拓展字段">
                <a-input
                  placeholder="请输入拓展字段"
                  v-model="queryParam.ext"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="还款类型">
                <a-select
                  v-model="queryParam.payType"
                  placeholder="请选择还款类型"
                  allowClear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="00">正常还款</a-select-option>
                  <a-select-option value="01">展期还款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="支付通道">
                <a-select
                  v-model="queryParam.channel"
                  placeholder="请选择支付通道"
                  allowClear
                  show-search
                  :filter-option="filterOption">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="chillPay">chillPay</a-select-option>
                  <a-select-option value="flow">flow</a-select-option>
                  <a-select-option value="hipay">hipay</a-select-option>
                  <a-select-option value="inpay">inpay</a-select-option>
                  <a-select-option value="moneySpace">moneySpace</a-select-option>
                  <a-select-option value="moneySpaceZ">moneySpaceZ</a-select-option>
                  <a-select-option value="mongo">mongo</a-select-option>
                  <a-select-option value="payStar">payStar</a-select-option>
                  <a-select-option value="toBestPay">toBestPay</a-select-option>
                  <a-select-option value="topPay">topPay</a-select-option>
                  <a-select-option value="tz_cellulant">tz_cellulant</a-select-option>
                  <a-select-option value="unPay">unPay</a-select-option>
                  <a-select-option value="xendit">xendit</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="还款状态">
                <a-select
                  v-model="queryParam.status"
                  placeholder="请选择还款状态"
                  allowClear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="01">成功</a-select-option>
                  <a-select-option value="02">失败</a-select-option>
                  <a-select-option value="03">还款中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            
          </template>
          <a-col :md="12" :sm="16">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a-button type="primary" @click="handleExport" icon="download" style="margin-left: 8px">导出</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
        :scroll="{ x: 1500 }">
        <span slot="createdTime" slot-scope="text">
          {{ text ? formatDateTime(text) : '-' }}
        </span>
        <span slot="updatedTime" slot-scope="text">
          {{ text ? formatDateTime(text) : '-' }}
        </span>
        <span slot="payType" slot-scope="text">
          {{ formatPayType(text) }}
        </span>
        <span slot="status" slot-scope="text">
          {{ formatStatus(text) }}
        </span>
        <!-- 操作列 按钮插槽 -->
        <template slot="action" slot-scope="text, record">
          <a-button type="link" @click="handleHandle(record)" v-if="isRepayOpr">处理</a-button>
        </template>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>

    <!-- 还款时间 选择弹窗（已加加载） -->
    <a-modal
      v-model="repayModalVisible"
      title="还款时间"
      @cancel="repayModalVisible = false"
      @ok="confirmRepayTime"
      okText="确认"
      cancelText="取消"
      :confirm-loading="repayLoading"
    >
      <a-form layout="vertical">
        <a-form-item label="确认还款时间">
          <a-date-picker
            v-model="repayTime"
            format="YYYY-MM-DD"
            :show-time="false"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getRepaymentList, exportRepaymentList, processFailRepay } from '@/webpublicapi/repayment'
import moment from 'moment'

export default {
  name: 'RepaymentList',
  data () {
    return {
      toggleSearchStatus: false,
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      isRepayOpr: false,
      dataSource: [],
      queryParam: {
        orderNo: '',
        mobileNo: '',
        ext: '',
        payinId: '',
        payType: '',
        channel: '',
        status: '',
        timeRange: [],
      },
      loading: false,
      // 新增 处理订单相关
      repayModalVisible: false,
      repayTime: null,
      currentRecord: null, // 当前选中的订单
      repayLoading: false, // 新增：弹窗确认按钮加载状态
    }
  },
  computed: {
    columns () {
      const cols = [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          align: 'left'
        },
        {
          title: '客户姓名',
          dataIndex: 'custName',
          key: 'custName',
          width: 200,
          align: 'left'
        },
        {
          title: '手机号',
          dataIndex: 'mobileNo',
          key: 'mobileNo',
          align: 'left'
        },
        {
          title: '交易编号',
          dataIndex: 'payoutId',
          key: 'payoutId',
          align: 'left'
        },
        {
          title: '拓展字段',
          dataIndex: 'ext',
          key: 'ext',
          align: 'left'
        },
        {
          title: '还款金额',
          dataIndex: 'amount',
          key: 'amount',
          align: 'left'
        },
        {
          title: '发起时间',
          dataIndex: 'createdTime',
          key: 'createdTime',
          align: 'left',
          scopedSlots: { customRender: 'createdTime' }
        },
        {
          title: '更新时间',
          dataIndex: 'updatedTime',
          key: 'updatedTime',
          align: 'left',
          scopedSlots: { customRender: 'updatedTime' }
        },
        {
          title: '还款类型',
          dataIndex: 'payType',
          key: 'payType',
          align: 'left',
          scopedSlots: { customRender: 'payType' }
        },
        {
          title: '支付通道',
          dataIndex: 'channel',
          key: 'channel',
          align: 'left'
        },
        {
          title: '还款状态',
          dataIndex: 'status',
          key: 'status',
          align: 'left',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          align: 'center',
          width: '100px',
          scopedSlots: { customRender: 'action' }
        }
      ]
      return cols
    }
  },
  created() {
    this.getLocalStorageRoleList();
  },

  mounted () {
    // getLocalStorageRoleList();
    // this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      const params = {
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize,
        ...this.getQueryParams()
      }
      
      getRepaymentList(params).then(res => {
        this.loading = false
        if (res.code === 1000) {
          this.dataSource = res.data.rows || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('查询失败')
        console.error(err)
      })
    },

    getLocalStorageRoleList() {
      try {
        const roleCodes = JSON.parse(localStorage.getItem('roleCodes') || '[]');
        const isValidArray = Array.isArray(roleCodes);

        this.isRepayOpr = isValidArray && roleCodes.includes('repay_opr');
        console.log(this.isRepayOpr, "111");
        
      } catch {
        this.isRepayOpr = false;
      }
    },

    getQueryParams () {
      const params = {}
      if (this.queryParam.orderNo) params.orderNo = this.queryParam.orderNo
      if (this.queryParam.mobileNo) params.mobileNo = this.queryParam.mobileNo
      if (this.queryParam.ext) params.ext = this.queryParam.ext
      if (this.queryParam.payinId) params.payinId = this.queryParam.payinId
      if (this.queryParam.payType) params.payType = this.queryParam.payType
      if (this.queryParam.channel) params.channel = this.queryParam.channel
      if (this.queryParam.status) params.status = this.queryParam.status
      
      if (this.queryParam.timeRange && this.queryParam.timeRange.length === 2) {
        params.startTime = moment(this.queryParam.timeRange[0]).format('YYYY-MM-DD') + ' 00:00:00'
        params.endTime = moment(this.queryParam.timeRange[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      
      return params
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    searchQuery () {
      this.form.pageNum = 1
      this.loadData()
    },
    searchReset () {
      this.queryParam = {
        orderNo: '',
        mobileNo: '',
        ext: '',
        payinId: '',
        payType: '',
        channel: '',
        status: '',
        timeRange: [],
      }
      this.form.pageNum = 1
      this.loadData()
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    handleToggleSearch () {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    handleExport () {
      this.loading = true
      const params = this.getQueryParams()
      
      exportRepaymentList(params).then(res => {
        this.loading = false
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `还款列表_${moment().format('YYYYMMDDHHmmss')}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(err => {
        this.loading = false
        this.$message.error('导出失败')
        console.error(err)
      })
    },
    formatDateTime (timestamp) {
      if (!timestamp) return '-'
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    formatPayType (value) {
      const typeMap = {
        '00': '正常还款',
        '01': '展期还款'
      }
      return typeMap[value] || value || '-'
    },
    formatStatus (value) {
      const statusMap = {
        '01': '成功',
        '02': '失败',
        '03': '待还款'
      }
      return statusMap[value] || value || '-'
    },

    // ============== 新增：处理按钮逻辑 ==============
    handleHandle(record) {
      // 1. 弹出确认提示
      this.$confirm({
        title: '确认',
        content: '已确认该笔订单支付凭证真实性?',
        onOk: () => {
          // 2. 确认后打开日期选择弹窗
          this.currentRecord = record; // 保存当前订单
          this.repayTime = null; // 清空时间
          this.repayModalVisible = true;
        }
      })
    },
    confirmRepayTime() {
      // 3. 选择时间后确认
      if (!this.repayTime) {
        this.$message.warning('请选择还款时间');
        return;
      }
      const repayTimeStr = moment(this.repayTime).format('YYYY-MM-DD');
      
      let params = {
        payoutId: this.currentRecord.payoutId,
        repayTime: repayTimeStr
      }

      // 开启加载状态
      this.repayLoading = true;

      processFailRepay(params).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg || '处理成功');
        } else {
          this.$message.error(res.msg || '处理失败')
        }
      }).catch(err => {
        this.$message.error('处理失败')
        console.error(err)
      }).finally(() => {
        // 无论成功失败，都关闭加载、弹窗并刷新列表
        this.repayLoading = false;
        this.repayModalVisible = false;
        this.loadData();
      }) 
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  padding: 16px;
  background: #fff;
}
</style>